import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { CsvListState, CsvList } from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: CsvListState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const downloadState = state.download;
    downloadState.error = false;
    downloadState.errorTitle = undefined;
    downloadState.errorDetails = undefined;
};
export const mutations: MutationTree<CsvListState> = {
    // CSVファイル検索系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; csv: Array<CsvList> }) {
        state.count = payload.count;
        state.lists = payload.csv;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // CSVファイルダウンロード系
    [types.CSV_DOWNLOAD_START](state) {
        resetErrors(state);
        const csvDownloadState = state.download;
        csvDownloadState.isProcessing = true;
    },

    [types.CSV_DOWNLOAD_SUCCESS](state) {
        const csvDownloadState = state.download;
        csvDownloadState.isProcessing = false;
    },

    [types.CSV_DOWNLOAD_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const csvDownloadState = state.download;
        csvDownloadState.errorTitle = payload.errorTitle;
        csvDownloadState.errorDetails = payload.errorDetails;
        csvDownloadState.error = true;
        csvDownloadState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const downloadState = state.download;
        downloadState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.lists = undefined;
        state.count = 0;
    },
};
